<template>
  <el-form :model="form" ref="form" @submit.prevent.native="onSubmit">
    <el-form-item>
      <el-row :gutter="15">
        <el-col :xs="8" :sm="6">
          <brand-upload :brand="brand"/>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item label="Brand name" prop="name">
      <el-input v-model="form.name" placeholder="Enter brand name"></el-input>
    </el-form-item>
    <el-form-item label="Country of Origin" prop="country_id">
      <app-countries v-model="form.country_id"/>
    </el-form-item>
    <el-form-item label="Description in up to 500 characters" prop="desc">
      <el-input v-model="form.desc" placeholder="Enter brand description" type="textarea" :autosize="{ minRows: 2 }"></el-input>
    </el-form-item>
    <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
  </el-form>
</template>

<script>
import AppCountries from '@/components/App/AppCountries'
import BrandUpload from '@/components/Brand/BrandUpload'

export default {
  components: {
    AppCountries,
    BrandUpload,
  },
  props: {
    brand: Object,
  },
  data() {
    return {
      loading: false,
      form: this.brand,
      rules: {
        'name': [
          { required: true, message: 'Enter brand name.', trigger: 'blur' },
        ],
        'country_id': [
          { required: true, message: 'Select country of origin.', trigger: 'blur' },
        ],
        'desc': [
          { required: true, message: 'Enter brand description.', trigger: 'blur' },
          { min: 140, max: 500, message: 'Length should be 140 to 280.', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          this.loading = false
          return false
        }
        this.loading = true
        try {
          var { data } = await this.$http.put(`/brands/${ this.brand.id }`, {
            _id: this.brand.id,
            name: this.form.name,
            country_id: this.form.country_id,
            desc: this.form.desc,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }
        this.$message.success(data.message)
      })
    },
  },
}
</script>

<style>

</style>
